module.exports = __webpack_public_path__ + "img/black-arrow.b11551d7.svg";